<script setup lang="ts"></script>

<template>
    <div class="flex gap-8rem my-5rem">
        <div class="left flex-grow-1">
            <h2 class="ktg-title-02 mb-2_5rem">{{ $t('meine_geschaefte') }}</h2>
            <p class="ktg-body-lead mb-5rem" v-html="$t('my_geschaefte_unauth_info_text')"></p>
        </div>
    </div>
</template>

<style scoped>
.left {
    max-width: 52rem;
}
</style>
